import React, { useState, useEffect } from 'react';
import Script from 'next/script';
import PropTypes from 'prop-types';
import {
  ArticleSubHeader,
} from '@fuww/library/src/Article';
import Headline3
from '@fuww/library/src/Typography/Heading/Headline3';
import { useIntl } from 'react-intl';
import { GridCell } from '@fuww/library/src/Grid';
import CaseArticleBody, { StyledGrid }
from '@fuww/library/src/Case';
import { useSiteContext } from '../../SiteContext';
import Head from '../../Head';
import getArticleJsonLdData from '../../../lib/getArticleJsonLdData';
import getArticleSubjectType from '../../../lib/getArticleSubjectType';
import { articlePropertyTypes } from '../Article';
import BreadCrumbs from '../Article/BreadCrumb';
import { metaImageDimensions } from '../../../lib/constants';
import shareList from '../../../lib/shareData';
import FormattedDate from '../../FormattedDate';
import SocialButtons from '../Article/SocialButtons';
import messages from '../../../lib/messages';

const CaseStudy = ({ data, field }) => {
  const intl = useIntl();
  const article = data[field];

  const [locationHref, setLocationHref] = useState();

  useEffect(() => {
    setLocationHref(window.location.href);
  }, []);

  const {
    id,
    title,
    description,
    insertedAt,
    creator,
    body,
    imageUrls: originalImageUrls,
  } = article;
  const [metaImageUrl, ...imageUrls] = originalImageUrls;

  const {
    url, origin, locale, prefix, hasLocalNews, newsboard,
  } = useSiteContext();

  const filteredShareList = locationHref && shareList({
    title,
    url: locationHref,
    media: metaImageUrl,
    locale,
  })
    .filter((share) => !share.checkMedia || imageUrls[0]);
  const { name: author } = creator;

  return (
    <>
      <Head
        title={title}
        description={description}
        imageUrl={metaImageUrl}
        imageDimensions={metaImageDimensions}
        insertedAt={insertedAt}
        author={author}
        jsonLdData={getArticleJsonLdData(article, url, origin)}
        subjectType={getArticleSubjectType(prefix, hasLocalNews)}
        subjectId={id}
        payload={{ newsboard }}
      >
        <link rel="stylesheet" href="https://media.fashionunited.com/media/bootstrap/3.4.1/css/bootstrap-custom.min.css" crossOrigin="anonymous" />
      </Head>
      <StyledGrid>
        <GridCell padding="0 0 20px">
          <BreadCrumbs article={article} />
        </GridCell>
        <GridCell padding="0 0 4px">
          <Headline3 tag="h1">
            {title}
          </Headline3>
        </GridCell>
        <GridCell padding="0">
          <ArticleSubHeader
            articleBy={intl.formatMessage(messages.articleBy, { author })}
            insertedAt={<FormattedDate value={insertedAt} />}
            categoryTitle="Case Studies"
            socialButtons={(
              <SocialButtons shareList={filteredShareList} center />
            )}
          />
          <CaseArticleBody
            dangerouslySetInnerHTML={{ __html: body }}
          />
          <Script
            src="https://cdn.jsdelivr.net/npm/jquery@1.12.4/dist/jquery.min.js"
            // eslint-disable-next-line max-len
            integrity="sha384-nvAa0+6Qg9clwYCGGPpDQLVpLNn0fRaROjHqs13t4Ggj3Ez50XnGQqc/r8MhnRDZ"
            crossOrigin="anonymous"
          />
          <Script
            src="https://cdn.jsdelivr.net/npm/bootstrap@3.4.1/dist/js/bootstrap.min.js"
            // eslint-disable-next-line max-len
            integrity="sha384-aJ21OjlMXNL5UyIl/XNwTMqvzeRMZH2w8c5cRVpzpU8Y5bApTppSuUkhZXN0VxHd"
            crossOrigin="anonymous"
          />
        </GridCell>
      </StyledGrid>
    </>
  );
};

CaseStudy.propTypes = {
  ...articlePropertyTypes,
  data: PropTypes.shape({}),
};
CaseStudy.defaultProps = {
  data: {},
};

export default CaseStudy;
